const WorkspacesPageTableSkeletonRow = () => (
  <div className="flex h-6 justify-between gap-3 animate-pulse">
    <div className="bg-ds-natural-50 w-6 rounded-md" />
    <div className="bg-ds-natural-50 grow rounded-md" />
  </div>
);

export interface WorkspacesPageTableSkeletonProps {
  count?: number;
}

export const WorkspacesPageTableSkeleton = ({
  count = 4,
}: WorkspacesPageTableSkeletonProps) => {
  return (
    <div className="flex flex-col gap-9 p-4 pb-6">
      {Array.from(Array(count)).map((_, index) => (
        <WorkspacesPageTableSkeletonRow key={index} />
      ))}
    </div>
  );
};
